<template>
  <dx-offer-intro product="p-move" />
</template>

<script>
import DxOfferIntro from '~/domains/offer/components/DX-OfferIntro'

export default {
  name: 'PMoveIntro',
  components: {
    DxOfferIntro,
  },
  layout: 'website',
  // maybe use a dynamic layout here some day?
  // layout: ({ store }) => (store.getters.isLoggedIn ? 'default' : 'website'),
  transition: 'none',
  meta: {
    isPublic: true,
    trackingId: 'dextra.privatrechtsschutz.p-move.antragsstrecke',
    trackingGroup: ['rechtsschutz', 'privatrechtsschutz'],
  },
  nuxtI18n: {
    paths: {
      de: '/privatrechtsschutz/p-move/antragsstrecke/',
      fr: '/protection-juridique-privee/p-move/formulaire-de-demande/',
    },
  },
}
</script>
